export default ({ app }) => {

  const script = document.createElement('script')
  script.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + process.env.ZENDESK_CHAT_KEY
  script.id =  'ze-snippet'
  script.async = true
  
  const hideZendesk = () => {
    window.zE('messenger', 'hide');
  }

  const checkZendesk = () => {
    if (window.zE) {
      hideZendesk();
    } else {
      const observer = new MutationObserver(() => {
        if (window.zE) {
          hideZendesk();
          observer.disconnect();
        }
      });
      observer.observe(document.body, {childList: true, subtree: true});
    }
  };
  
  if (process.client) {
    const loadZendesk = () => {
      // Remove event listeners once zendesk loaded is loaded
      window.removeEventListener('scroll', loadZendesk);
      window.removeEventListener('click', loadZendesk);
      window.removeEventListener('mousemove', loadZendesk);
      window.removeEventListener('keypress', loadZendesk);
      window.removeEventListener('touchstart', loadZendesk);
      document.body.appendChild(script)

      checkZendesk();
    }

    // Add event listeners for multiple interactions
    window.addEventListener('scroll', loadZendesk, {once: true});
    window.addEventListener('click', loadZendesk, {once: true});
    window.addEventListener('mousemove', loadZendesk, {once: true});
    window.addEventListener('keypress', loadZendesk, {once: true});
    window.addEventListener('touchstart', loadZendesk, {once: true});

  }
}